'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactNode } from 'react';
import { PrV2StickyGroupGuide } from './pr-v2-sticky-group-guide';
import { cn } from '@/lib/utils';
type PrV2GroupSectionLayoutProps = ComponentProps<'div'> & {
  guide: ReactNode;
};
export function PrV2GroupSectionLayout(t0) {
  const $ = _c(15);
  let children;
  let className;
  let guide;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      guide,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = guide;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    guide = $[3];
    props = $[4];
  }
  const t1 = guide && "@min-[64rem]/pr-diff:grid @min-[64rem]/pr-diff:grid-cols-[minmax(14rem,18rem)_minmax(0,1fr)] @min-[64rem]/pr-diff:items-start @min-[64rem]/pr-diff:gap-5 @min-[64rem]/pr-diff:space-y-0";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = cn(className, t1);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== guide) {
    t3 = guide ? <PrV2StickyGroupGuide>{guide}</PrV2StickyGroupGuide> : null;
    $[8] = guide;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== t2 || $[13] !== t3) {
    t4 = <div {...props} className={t2}>{t3}{children}</div>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}